var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAttachments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.945,
    height: 13.945,
    viewBox: "0 0 13.945 13.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.831,5.853l3.361-3.361a.721.721,0,0,0-.046-1.017.721.721,0,0,0-1.017-.046L5.768,4.789,2.089,1.11a.721.721,0,0,0-1.017-.046.722.722,0,0,0,.046,1.017L4.8,5.761,1.428,9.129a.721.721,0,0,0,.046,1.017.786.786,0,0,0,.518.234.655.655,0,0,0,.5-.188L5.86,6.824,9.54,10.5a.788.788,0,0,0,.518.234.657.657,0,0,0,.5-.188.721.721,0,0,0-.046-1.017Z",
    transform: "translate(-1.245 6.979) rotate(-45)",
    fill: "#26B963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAttachments);
export default __webpack_public_path__ + "static/media/addAttachments.dcca9e8f5222fbe80d234728d1823568.svg";
export { ForwardRef as ReactComponent };